// import LogoImg from '../shared/icons/ic_logo.svg';
// import LogoBlack from '../shared/icons/ic_logo_black.svg';
import '../app/index.scss';
// import Icons from './Icons';

export function Logo({ marginBottom = 10, type, onClick }) {
  if (type === 'background') {
    return (
      <>
        {/* <div
          style={{
            backgroundColor: '#F0F5F2',
            width: '100%',
            padding: 8,
            borderRadius: 5,
            marginBottom: 28,
            display: 'flex',
            alignItems: 'center',
            height: 60,
          }}
        >
          <img src={Plans} alt="logo" style={{ height: 25, marginRight: 10 }} />
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <span style={{
              marginBottom: 5, color: 'green', fontWeight: 'bold', marginLeft: 20,
            }}
            >
              Upgrade plan
            </span>
            <span style={{
              marginTop: 5, fontSize: 12, color: 'green', marginLeft: 20,
            }}
            >
              Expires on Jan 12, 2024
            </span>
          </div>
        </div> */}

        <div className="logo-background-shade" onClick={onClick}>
          {/* <img className="store-logo" alt="logo" style={{ height: 55 }} /> */}
          <div className="store-logo" style={{ height: 47, width: 110 }}>
            {' '}
            { ' ' }
            {' '}
          </div>
        </div>
      </>
    );
  }
  return (
    <div
      style={{
        marginBottom,
        alignItems: 'center',
        display: 'flex',
        // paddingRight: 30,
      }}
    >
      {/* <img src={LogoBlack} alt="logo" style={{ height: 55 }} /> */}
      <div className="store-logo" style={{ height: 47, width: 130 }}>
        {' '}
        { ' ' }
        {' '}
      </div>
    </div>
  );
}
